import React from "react";
import { useFormikContext } from "formik";
import { TFormValues } from "../../types";
import ResourcesCards from "../../../Resources/ResourcesCards";

const GuidedResults: React.FC<{}> = () => {
  const { values } = useFormikContext<TFormValues>();

  const filter = {
    state: values["location"] || null,
    concern: values.concern,
    outcomes: values.outcomes,
  };

  return (
    <div className="container">
      <ResourcesCards filter={filter} resultsView />
    </div>
  );
};
export default GuidedResults;
